// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"37cf6683","208":"65a90953","236":"81c18f11","353":"4bd2621f","512":"c7dd8e92","549":"cb5f3d1d","813":"c95738b3"}[chunkId] + ".chunk.js";
};